<template>
  <div class="specifications">
    <div class="border-bottom flex">
      <div>
        <div class="top">图片规格</div>
        <div>1920*1080</div>
      </div>
      <div>
        <div class="top">单路每秒处理图片占用芯片百分比</div>
        <div>
          <Input v-if="showInput" v-model="form.chipRatio"></Input>
          <span v-else>{{form.chipRatio}}</span>
        </div>
      </div>
      <div>
        <div class="top">单路每秒处理图片数量</div>
        <div>
          <Input v-if="showInput" v-model="form.images"></Input>
          <span v-else>{{form.images}}</span>
        </div>
      </div>
      <div>
        <div class="top">单路芯片每秒最大处理数</div>
        <div>
          <Input v-if="showInput" v-model="form.qps"></Input>
          <span v-else>{{form.qps}}</span>
        </div>
      </div>
    </div>
    <div class="mt-20 border-bottom flex">
      <div>
        <div class="top">硬盘占用(M)</div>
        <div>
          <Input v-if="showInput" v-model="form.disk"></Input>
          <span v-else>{{form.disk}}</span>
        </div>
      </div>
      <div>
        <div class="top">内存占用(M)</div>
        <div>
          <Input v-if="showInput" v-model="form.ram"></Input>
          <span v-else>{{form.ram}}</span>
        </div>
      </div>
      <div>
        <div class="top">显存占用(M)</div>
        <div>
          <Input v-if="showInput" v-model="form.vom"></Input>
          <span v-else>{{form.vom}}</span>
        </div>
      </div>
      <div>
        <div class="top">支持最大路数</div>
        <div>
          <Input v-if="showInput" v-model="form.maxRoad"></Input>
          <span v-else>{{form.maxRoad}}</span>
        </div>
      </div>
    </div>
    <div class="mt-20 border-bottom flex">
      <div>
        <div class="top">检测目标最小像素值</div>
        <div>
          <Input v-if="showInput" v-model="form.aimMinPixel"></Input>
          <span v-else>{{form.aimMinPixel}}</span>
        </div>
      </div>
      <div>
        <div class="top">算法使用方式</div>
        <div>
          <Input v-if="showInput" v-model="form.serviceUseWay"></Input>
          <span v-else>{{getServiceUseWay(form.serviceUseWay)}}</span>
        </div>
      </div>
      <div>
        <div class="top">视频帧率</div>
        <div>
          <Input v-if="showInput" v-model="form.videoFramerate"></Input>
          <span v-else>{{form.videoFramerate}}</span>
        </div>
      </div>
      <div>
        <div class="top">结果展示方式</div>
        <div>
          <Input v-if="showInput" v-model="form.resultShowWay"></Input>
          <span v-else>{{getResultShowWay(form.resultShowWay)}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    technologyForm: Object,
    showInput: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      form: {
        chipRatio: "",
        images: "",
        qps: "",
        ram: "",
        vom: "",
        maxRoad: "",
        disk: "",
        aimMinPixel: "",
        serviceUseWay: "",
        videoFramerate: "",
        resultShowWay: ""
      }
    };
  },
  watch: {
    technologyForm() {
      this.form = { ...this.technologyForm };
    }
  },
  created() {
    this.form = { ...this.technologyForm };
  },
  methods: {
    getServiceUseWay(value) {
      if(value == "0") return "全部";
      if(value == 1) return "视频流";
      if(value == 2) return "图片数据";
      return "-/-";
    },
    getResultShowWay(value) {
      if(value == "0") return "全部";
      if(value == 1) return "视频流";
      if(value == 2) return "图片展示";
      if(value == 3) return "推理结果";
      return "-/-";
    },
  }
};
</script>

<style lang="scss" scoped>
.specifications {
  .border-bottom {
    border-bottom: 1px solid #f0f0f0;
  }
  .top {
    background-color: #fafafa;
  }
  .flex {
    display: flex;
    & > div {
      // width: 25%;
      // flex-basis: 0;
      // flex-grow: 1;
      &:nth-child(1) {
        width: 15%;
      }
      &:nth-child(2) {
        width: 35%;
      }
      &:nth-child(3) {
        width: 25%;
      }
      &:nth-child(4) {
        width: 25%;
      }
      & > div {
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        & > .ivu-input-wrapper {
          width: 80%;
        }
      }
    }
  }
}
</style>